import { baseSplitApi } from "../baseApi";

const kmtBasePath = "/kmt"
const getAllCRPClientsPath = `${kmtBasePath}/get_all_crp_clients`
const resendMailToClientPath = `${kmtBasePath}/resend_mail_to_client`
export const RESEND_MAIL_TAG = "resendMailTag"

export const kmtAPI = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        getAllCRPClients: build.query({
            query: () => {
                return {
                    url: getAllCRPClientsPath
                }
            },
            providesTags: [RESEND_MAIL_TAG]
        }),
        resendMailToClient: build.mutation({
            query: (body) => {
                return {
                    url: resendMailToClientPath,
                    method: 'POST',
                    body
                }
            },
            invalidatesTags:[RESEND_MAIL_TAG]
        }),
        getOnboardClients: build.query({
            query: () => {
                return {
                    url: '/onboarding/onboarding_clients',
                }
            },
        }),
        addOnboardData: build.mutation({
            query: (body) => {
                return {
                  method:"POST",
                  url: '/onboarding/onboarding_clients',
                  body
                }
            },
        }),
    })
})


export const { useGetAllCRPClientsQuery,useResendMailToClientMutation,useGetOnboardClientsQuery,useAddOnboardDataMutation } = kmtAPI